import { GetTokenSilentlyOptions, LogoutOptions } from '@auth0/auth0-react';
import { PostHog } from 'posthog-js';
import { addLearnosityBffBreadcrumb } from '../utils/learnositySentry';
import { fetchLearnosityStartupData } from './fetchLearnosityStartupData';
import type { DataLrnSession } from '../custom-hooks/useLrnSession';

function isSession(value: unknown): value is DataLrnSession {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return false;
  const { sessionId, status, previousActivityId, count } = value as Record<string, unknown>;
  return (
    typeof sessionId === 'string' &&
    sessionId.trim().length > 0 &&
    (status === 'new' || status === 'Incomplete' || status === 'previous') &&
    (previousActivityId === undefined || typeof previousActivityId === 'string') &&
    (count === undefined || (typeof count === 'number' && Number.isInteger(count) && count >= 0))
  );
}

export const getIncompleteStatus = async (
  activityId: string,
  userId: string,
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>,
  logout: (options?: LogoutOptions) => Promise<void>,
  posthog: PostHog,
  schoolYearStartDate?: string,
) => {
  const fields = { activityReference: activityId, learnerId: userId };
  const schoolYearParam = schoolYearStartDate ? `&schoolYearStartDate=${encodeURIComponent(schoolYearStartDate)}` : '';
  const data = await fetchLearnosityStartupData(
    {
      operation: 'get_incomplete_status',
      path: `/v1/learnosity/assessments/incomplete-status?activityId=${activityId}&publicUserId=${userId}${schoolYearParam}`,
      fields,
      validate: isSession,
    },
    getAccessTokenSilently,
    logout,
    posthog,
    { terminalStartup: false },
  );
  addLearnosityBffBreadcrumb('get_incomplete_status', {
    ...fields,
    responseSessionId: data.sessionId,
    responseStatus: data.status,
    responseCount: data.count,
    previousActivityReference: data.previousActivityId,
  });
  return data;
};
